import { ThunkDispatch } from "redux-thunk";

import { connect } from 'react-redux';

import { Action, closeTextShapeDialog, submitTextShapeDialog, textShapeDialogTextChanged } from '../actions';
import { getTextShapeDialogState, State } from '../reducers';

import TextFieldDialogView from '../components/TextFieldDialogView';

interface StateProps {
    readonly open: boolean,
    readonly titleKey: string,
    readonly labelKey: string,
    readonly text: string,
}

interface DispatchProps {
    readonly onDialogCancel: () => void,
    readonly onDialogSubmit: () => void,
    readonly onTextChanged: (text: string) => void,
}


const mapStateToProps = (state: State): StateProps => {
    const { open, text } = getTextShapeDialogState(state);
    return {
        open,
        titleKey: 'text_shape_dialog_title',
        labelKey: 'text_shape_dialog_label',
        text,
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onDialogCancel: () => {
            dispatch(closeTextShapeDialog());
        },
        onDialogSubmit: () => {
            dispatch(submitTextShapeDialog());
        },
        onTextChanged: (text: string) => {
            dispatch(textShapeDialogTextChanged(text));
        },
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TextFieldDialogView);



// WEBPACK FOOTER //
// ./src/containers/TextShapeDialog.ts